/* SV PDP dimensions — draft-only enhancement */
(function () {
  'use strict';

  function syncProductDimensions(event) {
    var summary = document.querySelector('[data-sv-dimensions-summary]');
    var valueEl = document.querySelector('[data-sv-dimensions-value]');
    if (!summary || !valueEl) return;

    var variant = event && event.detail && event.detail.variant;
    if (!variant) {
      var jsonNode = document.querySelector('[data-current-variant-json]');
      if (jsonNode) {
        try { variant = JSON.parse(jsonNode.value || jsonNode.textContent || '{}'); } catch (e) {}
      }
    }

    var dimensions = '';
    var candidates = variant && Array.isArray(variant.options) ? variant.options.slice() : [];
    var title = variant && variant.title ? String(variant.title) : '';
    if (title) candidates = candidates.concat(title.split(' / '));

    for (var i = 0; i < candidates.length; i++) {
      var candidate = String(candidates[i] || '').trim();
      if (/\s[xX]\s|volume/i.test(candidate)) {
        dimensions = candidate;
        break;
      }
    }

    if (!dimensions || dimensions === 'Default Title') {
      summary.hidden = true;
      return;
    }

    valueEl.textContent = dimensions;
    summary.hidden = false;
  }

  function boot() {
    syncProductDimensions();
    document.addEventListener('variant:change', syncProductDimensions);
    document.addEventListener('product:variant-change', syncProductDimensions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
